import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  contentContainer: {
    paddingLeft: "10px",
  },
}));
